<template>
  <div>
    <div>
      <h5 class="vue-title pull-left custom-header">
        <strong>{{ $t("STOREMANAGEMENT") }}</strong>
      </h5>
      <p
        class="float-right add-btn" 
        v-if="checkPermisssion('BRANCH', false)"
      >
        {{ $t("ADD") }}
        <a href="#/createStore">
          <em class="fas fa-plus-circle"></em>
        </a>
      </p>
      <b-input-group 
        class="pull-right search-store"
      >
        <template v-slot:prepend>
          <b-input-group-text @click="onSerach">
            <em class="fa fa-search"></em>
          </b-input-group-text>
        </template>
        <b-form-input
          size="sm"
          @keyup.enter="onSerach"
          autocomplete="off"
          v-model="searchKeyword"
        ></b-form-input>
      </b-input-group>
    </div>
    <c-table
      :table-data="partnerBranchListP.list"
      :fields="fields"
      :per-page="10"
      striped
      hover
      :total="partnerBranchListP.pageTotal"
      :update="update"
      :edit="onClickEditBtn"
      :delete="showDeleteModel"
      :sortTable="sortTable"
      :isBusy="isBusy"
      :pagination="pagination"
      :countPerPage="currentPage"
    ></c-table>
     <nav>
      <div class="pagination-module">
        <b-pagination
          :total-rows="partnerBranchListP.pageTotal"
          @change="pagination"
          :per-page="10"
          v-model="currentPage"
          :prev-text="$t('FORWARD')"
          :next-text="$t('NEXT')"
        />
      </div>
    </nav>
    

    <b-modal id="modal-delete" hide-footer>
      <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}</template>
      <p class="my-2">
        「クリニック」提携先マスターを削除しますがよろしいですか？
      </p>
      <hr />
      <b-row>
        <b-col class="col-6"></b-col>
        <b-col>
          <b-button
            variant="outline-danger"
            class="btn pull-right"
            size="sm"
            @click="deleteItem()"
            >{{ $t("DELETE") }}</b-button
          >
        </b-col>

        <b-col>
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="$bvModal.hide('modal-delete')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-Status" hide-footer>
      <template v-slot:modal-title>
        {{ $t("STATUSCHANGECONFIRMATION") }}
      </template>
      <p>ステータスを変更してもよろしいですか？</p>
      <hr />
      <b-row>
        <b-col class="col-6"></b-col>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="btn pull-right"
            @click="StatusChange()"
            >{{ $t("SUBMIT") }}</b-button
          >
        </b-col>

        <b-col>
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="$bvModal.hide('modal-Status')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import cTable from "@/components/Table.vue";
import { mapGetters } from "vuex";
import { checkPermisssion } from "@/shared/utils.js";

import {
  GET_PARTNER_STORES,
  UPDATE_BRANCH_STATUS,
  DELETE_PARTNER_BRANCH
} from "@/store/actions.type";

export default {
  name: "partnerList",
  data() {
    return {
      checkPermisssion: checkPermisssion,
      fields: [],
      sortField: "",
      sortDirection: "",
      isBusy: true,
      currentPage: 1,
      searchKeyword: ""
    };
  },
  components: { cTable },
  methods: {
    /**
     * Show Delete Modal
     * Input @param {object} row Seleted Row to Delete
     * Output PopUp the Delete Modal
     */
    showDeleteModel(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-delete");
    },
    /**
     * Edit the table row
     * Input @param {Number} userId Seleted Row id to Edit
     * Output  @param {Number} userId  append to routing Params then Redirect to edit page
     */
    onClickEditBtn(row) {
      this.$router.push({
        name: "createStoreEdit",
        params: { id: row.id }
      });
    },
    /**
     * Status function for table Row
     * Input 1,@param {Number} userID  selected Row ID 2,@param {string} status  (Active or Inactive)
     * Output @param {boolean}   data.status  status of the api call (true or false)
     */
    StatusChange() {
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let selectedItemId = _.get(this.selectedItemForDelete, "id", 0);
      this.$bvModal.hide("modal-Status");

      if (selectedItemId) {
        let status = _.get(this.selectedItemForDelete, "status", "");
        this.$store
          .dispatch(UPDATE_BRANCH_STATUS, {
            id: selectedItemId,
            status: status == "active" ? "inactive" : "active"
          })
          .then(data => {
            this.isLoading.hide();
            this.$toast.success({
              message: data.message
            });
            if (data.status) {
              this.isBusy = true;
              this.$store
                .dispatch(GET_PARTNER_STORES, {
                  search_query: this.searchKeyword,
                  field: this.sortField,
                  sort: this.sortDirection,
                  page: this.currentPage
                })
                .then(() => {
                  this.isBusy = false;
                });
            } else {
              this.$toast.error({
                message: data.message
              });
            }
          });
      } else {
        this.$bvModal.hide("modal-Status");
        this.isLoading.hide();
      }
    },
    /**
     * Show Status Change Modal
     * Input @param {object} row Seleted Row to Change status of it
     * Output PopUp the Status Change Modal
     */
    update(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-Status");
    },
    /**
     * Sort function on  table
     * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
     * Output @param {List}   response.list  Filtered List
     */
    sortTable(field, direction) {
      this.isBusy = true;
      this.sortField = field;
      this.sortDirection = direction;
      this.$store
        .dispatch(GET_PARTNER_STORES, {
          search_query: this.searchKeyword,
          page: this.currentPage,
          field: this.sortField,
          sort: this.sortDirection
        })
        .then(data => {
          this.isBusy = false;
        });
    },
    /*Pagination */
    pagination(page) {
      this.currentPage = page;
      this.isBusy = true;
      this.$store
        .dispatch(GET_PARTNER_STORES, {
          search_query: this.searchKeyword,
          page: this.currentPage,
          field: this.sortField,
          sort: this.sortDirection
        })
        .then(data => {
          this.isBusy = false;
        });
    },
    /**
     * Delete function for table Row
     * Input @param {Number} userID selected Row ID
     * Output @param {Boolean}   data.status  Boolean status Api call
     */
    deleteItem() {
      this.$toast.removeAll();
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });

      this.$store
        .dispatch(DELETE_PARTNER_BRANCH, { id: this.selectedItemForDelete.id })
        .then(data => {
          this.isLoading.hide();
          console.log("data", data);

          if (data) {
            if (data.status) {
              this.$toast.success({
                message: data.message
              });
              this.isBusy = true;
              this.pagination(this.currentPage);
            }
          } else {
            this.$toast.error({
              message: data.message
            });
          }
        });
      this.$bvModal.hide("modal-delete");
    },

    /**
     * onSearch function on  table
     * Input @param {String} search_query Search keyword
     * Output @param {List}   response.list  Filtered List
     */
    onSerach() {
      /* param: page:1 after search paginaiton should be first page, search query, sort fields.  */
      this.pagination(1);
    }
  },
  computed: {
    ...mapGetters(["partnerBranchListP"])
  },
  created() {
    this.$toast.removeAll();
    /* Onload calling partner branchs */
    this.$store
      .dispatch(GET_PARTNER_STORES, {
        field: "id",
        sort: "desc"
      })
      .then(dat => {
        this.isBusy = false;
      });
    /* Table headders */
    this.fields = [
      {
        key: "user.userid",
        label: this.$t("ID"),
        sortable: false,
        class: "text-left",
      },
      { key: "name", label: "提携先名", sortable: true, class: "text-left" },
      {
        key: "custom_address",
        label: "住所",
        sortable: false,
        class: "text-left",
      },
      {
        key: "personIncharge_contactaname",
        label: "担当者姓名",
        sortable: false,
        class: "text-left",
      },
      {
        key: "contact_no",
        label: "電話番号",
        sortable: true,
        class: "text-left"
      }
    ];
    /* If user has permission will add status and edit columns */
    if (checkPermisssion("BRANCH", false)) {
      this.fields.push({
        key: "status",
        label: this.$t("STATUS"),
        sortable: false
      });
      this.fields.push({
        key: "actions",
        label: this.$t("ACTION"),
        sortable: false
      });
    } else {
      this.fields.push({
        key: "status_disable",
        label: this.$t("STATUS"),
        sortable: false
      });
    }
  }
};
</script>
<style>
.add-btn{
  font-size: 17px;    margin-top: 14px;
}
.search-store{
  width:200px;margin:10px 20px;height:10px
}
</style>